import { render, staticRenderFns } from "./SingleLanguage.vue?vue&type=template&id=72d9ec5c&scoped=true"
import script from "./SingleLanguage.vue?vue&type=script&lang=js"
export * from "./SingleLanguage.vue?vue&type=script&lang=js"
import style0 from "./SingleLanguage.vue?vue&type=style&index=0&id=72d9ec5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d9ec5c",
  null
  
)

export default component.exports